import React, {Component} from 'react';
import FJLocalStore from "../../../../store/FJLocalStore";

import Style from './FJRecordingSet.module.less';
import FJDropDownMenu from './FJDropDownMenu';

class FJRecordingSet extends Component {

  /**
   * @description dropmenu 显示的时候
   * @private
   */
  _onShow = () => {
    if (this.props.onShow) {
      this.props.onShow();
    }
  };

  /**
   * @description dropmenu 隐藏的时候
   * @private
   */
  _onHide = () => {
    if (this.props.onHide) {
      this.props.onHide();
    }
  };

  render() {
    let {
      cameraList,
      microphoneList,
      cameraActiveIndex,
      microphoneActiveIndex
    } = this.props;
    return (
      <div className={Style.box}>
        <h4 className={Style.title}>{FJLocalStore._('camera')}</h4>
        <FJDropDownMenu style={{marginBottom: '16px'}} list={cameraList} showIndex={cameraActiveIndex} showNumber='3'
                        onClick={(index) => {
                          this.props.changeRecordingConfig('cameraActiveIndex', index);
                        }}
                        onShow={this._onShow} onHide={this._onHide}/>
        <h4 className={Style.title}>{FJLocalStore._('microphone')}</h4>
        <FJDropDownMenu style={{marginBottom: '16px'}} list={microphoneList} showNumber='3'
                        showIndex={microphoneActiveIndex}
                        onClick={(index) => {
                          this.props.changeRecordingConfig('microphoneActiveIndex', index);
                        }}
                        onShow={this._onShow} onHide={this._onHide}/>
      </div>
    );
  }
}

export default FJRecordingSet;
